import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { ProjectRefService } from 'src/app/services/project-ref.service';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { MultimediaTypes, PopupOpenMode, PopupViewMode, ReferenceType } from 'src/app/common/enums/enums';
import { AppConstatnts } from 'src/app/common/constants/app-contstants';

@Component({
    selector: 'app-subheader-main',
    templateUrl: './subheader-main.component.html',
    styleUrls: ['./subheader-main.component.scss'],
    standalone: false
})
export class SubheaderMainComponent implements OnInit {
  @Input() loadingState: boolean = false;
  @Input() showProjects: boolean = true;
  @Input() showBreadCrumb: boolean = true;
  @Input() showFamilyBreadCrumb: boolean = true;

  constructor(
    private router: Router,
    private dialogService: DialogService,
    private projectRefService: ProjectRefService,
    private translateHandler: TranslateHandler
  ) { }

  ngOnInit(): void {
  }
  titleMap = new Map<string, string>(
    [
      ["Multimedia", "lbl_media_list"],
      ["IndividualMain", "lbl_persons_list"],
      ["ReportsMenu", "lbl_reports"],
    ]
  );
  openPopup(name: string) {

    let projectName = this.projectRefService.getCurrentProject().projectName;

    let mainTitle = this.titleMap.get(name);
    this.dialogService.setFull().open(name, {
      id: 0,
      reference: {
        id: 0,
        type: ReferenceType.None,
        rawData: ""
      },
      title: this.translateHandler.translate('lbl_menu_list_title', [this.translateHandler.translate(mainTitle), projectName]) ?? "",
      mediaType: [MultimediaTypes.PHOTO, MultimediaTypes.DOC, MultimediaTypes.AUDIO, MultimediaTypes.VIDEO],
      viewMode: PopupViewMode.GalleryView, // Gallery or editor view
      editMediaId: 0, // MediaId which supposes to be edited
      editSourceId: 0,
      isStandAlone: true,
      mode: PopupOpenMode.List, // Todo: Make a enum
      showMode: [1]
    }
    )
      .subscribe(response => {
        if (response != null && response.data) {
          this.router.navigate([AppConstatnts.routerModes.TreeEditor]);
        }
      });
  }

}
